import { Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ClickComponentDirective} from "../../../directives/click-component.directive";
import {PositionDirective} from "../../../directives/position.directive";
import {ComponentEntity} from "../../../entities/component-entity";
import {defaultComponentEntity} from "../../../commons/defaults-components";
import {PositionAlignment} from "../../../entities/properties";
import {getAlignmentText} from "../../../commons/compontents-utils";

@Component({
  selector: 'lib-s10',
  imports: [CommonModule, ClickComponentDirective, PositionDirective],
  templateUrl: './S10.component.html',
  styleUrl: './S10.component.scss',
  standalone: true
})
export class S10Component {
  cdkDragBoundaryName = input<string>('');
  resizeHeight = output<{newHeight:number,currently:number}>()

  component = input<ComponentEntity>(defaultComponentEntity());

  constructor() {
  this.component().properties.text ="Power by"
  this.component().properties.base64Image = "https://media.s10plus.com/s10plus_20250506_202939.png"
  }

  getAlignmentImage(positionAlignment: PositionAlignment): string {
    switch (positionAlignment) {
      case PositionAlignment.LEFT:
        return 'flex-row-reverse';
      case PositionAlignment.BOTTOM:
        return 'flex-col';
      case PositionAlignment.RIGHT:
        return 'flex-row';
      case PositionAlignment.TOP:
        return 'flex-col-reverse';
    }
  }

  protected readonly getAlignmentText = getAlignmentText;
}
